import { formatISO } from 'date-fns';
import { validateEmail } from "../config/utils";

export const validateUnapplied = (amounts, payorInfo, paymentInfo) => {
    let errors = '';
    if (amounts.total <= 0 || amounts.base <= 0) errors = 'The amount being paid must be greater than $0.00';
    if (!amounts.total || !amounts.base) errors = `${errors}${errors ? ' ;' : ''}Please re-enter the payment amount`;
    if (!payorInfo.posterName) errors = `${errors}${errors ? ' ;' : ''}The payor's name is required`;
    if (payorInfo.posterZip && payorInfo.posterZip.value && payorInfo.posterZip.value.length !== 5) {
        errors = `${errors}${errors ? '; ' : ''}The payor zip code is invalid`;
    }
    if (payorInfo.posterPhone && payorInfo.posterPhone.value && payorInfo.posterPhone.value.length !== 10) {
        errors = `${errors}${errors ? '; ' : ''}The payor phone number is invalid`;
    }
    if (payorInfo.payorEmail && !validateEmail(payorInfo.payorEmail)) errors = `${errors}${errors ? '; ' : ''}The payor email address is invalid`;
    if (!paymentInfo.firstName || !paymentInfo.lastName) errors = `${errors}${errors ? '; ' : ''}The party's first and last name are required`;
    if (paymentInfo.zip && paymentInfo.zip.value && paymentInfo.zip.value.length !== 5) {
        errors = `${errors}${errors ? '; ' : ''}The party zip code is invalid`;
    }
    if (paymentInfo.email && !validateEmail(paymentInfo.email)) errors = `${errors}${errors ? '; ' : ''}The party's email address is invalid`;
    if (paymentInfo.phone && paymentInfo.phone.value && paymentInfo.phone.value.length !== 10) {
        errors = `${errors}${errors ? '; ' : ''}The party's phone number is invalid`;
    }
    return errors;
}

export const getPaymentRequest = (courtId, amounts, payorInfo, paymentInfo) => {
    const unappliedInfo = {
        posterName: payorInfo.posterName,
        posterAddress: payorInfo.posterAddress,
        posterCity: payorInfo.posterCity,
        posterState: payorInfo.posterState,
        posterZip: payorInfo.posterZip ? payorInfo.posterZip.value : null,
        posterPhone: payorInfo.posterPhone ? payorInfo.posterPhone.formattedValue : null,
        posterEmail: payorInfo.posterEmail,
        firstName: paymentInfo.firstName,
        middleName: paymentInfo.middleName,
        lastName: paymentInfo.lastName,
        suffix: paymentInfo.suffix,
        partyId: paymentInfo.partyId,
        amount: paymentInfo.amount.floatValue,
        dob: paymentInfo.dob ? formatISO(paymentInfo.dob, {representation: 'date'}) : null,
        ssn: paymentInfo.ssn ? paymentInfo.ssn.value : null,
        license: paymentInfo.license,
        licenseState: paymentInfo.licenseState,
        address: paymentInfo.address,
        city: paymentInfo.city,
        state: paymentInfo.state,
        zip: paymentInfo.zip ? paymentInfo.zip.value : null,
        phone: paymentInfo.phone ? paymentInfo.phone.formattedValue : null,
        email: paymentInfo.email,
        violationDate: paymentInfo.violationDate ? formatISO(paymentInfo.violationDate, {representation: 'date'}) : null,
        posterReference: paymentInfo.posterReference
    };
    const payor = {
        name: payorInfo.posterName,
        address: payorInfo.posterAddress,
        city: payorInfo.posterCity,
        state: payorInfo.posterState,
        zip: payorInfo.posterZip ? payorInfo.posterZip.value : null,
        email: payorInfo.posterEmail,
        phone: payorInfo.posterPhone ? payorInfo.posterPhone.formattedValue : null
    };
    return {
        courtId: courtId,
        paymentDescription: `Unapplied bond/case payment for ${paymentInfo.firstName} ${paymentInfo.lastName}`,
        processingType: 'unapplied',
        partyName: `${paymentInfo.lastName}, ${paymentInfo.firstName}`,
        payorName: payorInfo.posterName,
        payorAddress: payorInfo.posterAddress,
        payorCity: payorInfo.posterCity,
        payorState: payorInfo.posterState,
        billingZip: payorInfo.posterZip ? payorInfo.posterZip.value : null,
        email: payorInfo.posterEmail,
        phone: payorInfo.posterPhone ? payorInfo.posterPhone.formattedValue : null,
        totalAmount: amounts.total,
        courtAmount: amounts.base,
        feeAmount: amounts.fee,
        payor: payor,
        unappliedInfo: unappliedInfo
    };
}